import { GridFilter } from "./GridFilter";

export class ContractToolFilter extends GridFilter {
  contractId: string;
}
